module.exports = __webpack_public_path__ + "static/media/nav3.97fc905a.svg";